import { ITicketsState } from '@telstra-connect/tickets/state';
import Route from './route-constants';

let lastVisitedIncidentListView = Route.TrackingRoute;

export interface ITicketsAppState {
    tickets: ITicketsState;
};

export const getLastVisitedIncidentListView = () => lastVisitedIncidentListView;

export const setLastVisitedIncidentListView = (url) => lastVisitedIncidentListView = url;

export const resetLastVisitedIncidentView = () => {
    lastVisitedIncidentListView = Route.IncidentsRoute;
}
